import axios from "axios";
import { callGetAPI } from "./API-Calling-service";
const API_URL = process.env.REACT_APP_CHANGEINITIATION_API_URL + "ApprovalHeads";
//const axios = require("axios");

export async function getApprovalHeads() {  
  return callGetAPI(API_URL);
  // console.log(API_URL);
  // return fetch(API_URL).then((response) => response.json());
}

